import {combineReducers} from "redux";
import resultVn1 from "./resultVn1";
import resultTn from "./resultTn";
///view

const resultDrawReducer = combineReducers({
    resultVn1,
    resultTn
});
export default resultDrawReducer;